import { schema } from "normalizr";
export const card = new schema.Entity("card");
export const section = new schema.Entity("section", {
  card
}, {
  idAttribute: "card-title"
});
export const page = new schema.Entity("page", {
  sections: [section]
}, {
  idAttribute: "key"
});
export const pagesSchema = new schema.Entity("pages", {
  pages: [page]
}, {
  idAttribute: "key"
});